var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12.5C9.81371 12.5 12.5 9.81371 12.5 6.5C12.5 3.18629 9.81371 0.5 6.5 0.5C3.18629 0.5 0.5 3.18629 0.5 6.5C0.5 9.81371 3.18629 12.5 6.5 12.5ZM7.0625 7.25C7.0625 7.56066 6.81066 7.8125 6.5 7.8125C6.18934 7.8125 5.9375 7.56066 5.9375 7.25V3.875C5.9375 3.56434 6.18934 3.3125 6.5 3.3125C6.81066 3.3125 7.0625 3.56434 7.0625 3.875V7.25ZM6.5 8.5625C6.81066 8.5625 7.0625 8.81434 7.0625 9.125C7.0625 9.43566 6.81066 9.6875 6.5 9.6875C6.18934 9.6875 5.9375 9.43566 5.9375 9.125C5.9375 8.81434 6.18934 8.5625 6.5 8.5625Z",
    fill: "#F00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.6324684d171844514d04c924f2362452.svg";
export { ForwardRef as ReactComponent };